import React from 'react';
import { Box } from 'theme-ui';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { getButtonFocus } from 'styles/variables';

export const Button = ({
  color,
  textColor,
  hidden = false,
  borderColor = 'transparent',
  onClick,
  children,
}: {
  color: string;
  textColor: string;
  hidden?: boolean;
  borderColor?: string;
  onClick?: () => void;
  children: any;
}) => {
  //
  const focus = getButtonFocus(
    borderColor !== 'transparent' ? borderColor : color,
    `0 0 0 1px ${borderColor !== 'transparent' ? borderColor : color}`
  ).replace('box-shadow: ', '');

  return (
    <Box
      as="button"
      sx={{
        outline: 'none',
        border: 'none',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px 30px',
        width: '150px',
        minHeight: '100%',
        borderRadius: '50px',
        background: color,
        boxShadow: `0 0 0 1px ${borderColor}`,
        color: textColor,
        visibility: hidden ? 'hidden' : 'auto',
        ...(window.dev &&
          !window.dev() && {
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.5,
              transition: 'opacity 0.2s',
            },
          }),

        '&:focus': {
          boxShadow: focus,
        },
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};

export const ReVisitTryAgain = ({
  // isCorrect,
  // correctColor = '',
  // incorrectColor = '',
  color = '',
  resetQuestion = () => {},
  // id = undefined,
  indexA,
  children,
}) => {
  return (
    <Button
      color="#fff"
      textColor={color}
      borderColor={color}
      onClick={() => {
        if (window.dev && window.dev()) {
          return;
        }

        // if (!isCorrect) {
        //   // resetQuestion(id);
        //   resetQuestion();
        // }
        // if(resetQuestion) {
        // }
        resetQuestion();

        const currentTopic = getCurrentTopic() as any;

        const interactionsInTopic = getInteractionsInTopic(currentTopic);

        const assessmentQuestions = interactionsInTopic.filter((c: any) => {
          return c.meta.subType === 'AssessmentQuestion';
        });

        const targetQuestion = assessmentQuestions.filter((c, i) => {
          return i === indexA;
        })[0] as any;

        const targetLocation = `${currentTopic.props.sId}/${targetQuestion.props.sId}`;

        window.location.hash = targetLocation;
        requestAnimationFrame(() => {
          const section = document.querySelector(
            `#i${targetQuestion.id}`
          ) as HTMLElement;

          section?.focus();
        });
        // console.log(targetLocation);
      }}
    >
      {/* {isCorrect ? 'Re-visit' : 'Try again'} */}

      {/* {enableReVisit && isCorrect && 'Re-visit'}
      {enableTryAgain && isCorrect && 'Try again'} */}

      {children}
    </Button>
  );
};
